import type { Menu, Permission, Role, User } from "@/types/entity";
import { PermissionType } from "@/types/enum";

const { GROUP, MENU, CATALOGUE } = PermissionType;

export const DB_MENU: Menu[] = [
	// root group
	{ id: "root_group", name: "", parentId: "", type: GROUP },
	// 重说
	{
		id: "zyusetu",
		parentId: "root_group",
		name: "重说",
		type: MENU,
		path: "/zyusetu",
	},
	// 用户管理
	{
		id: "management",
		parentId: "root_group",
		name: "企业设置",
		type: CATALOGUE,
		path: "/management",
	},
	{
		id: "management_account",
		parentId: "management",
		name: "账户管理",
		type: MENU,
		path: "/management/account",
		hidden: true,
	},
	// {
	// 	id: "management_role",
	// 	parentId: "management",
	// 	name: "角色管理",
	// 	type: MENU,
	// 	path: "/management/role",
	// },
	{
		id: "management_user",
		parentId: "management",
		name: "用户列表",
		type: MENU,
		path: "/management/user",
		hidden: true, // 模拟后台返回：用户没有员工管理权限
	},
	// 联系我们
	{
		id: "contact",
		parentId: "root_group",
		name: "联系我们",
		type: MENU,
		path: "/contact",
	},
	// 常见问题
	{
		id: "faq",
		parentId: "root_group",
		name: "常见问题",
		type: MENU,
		path: "/faq",
	},
	// 使用教程
	{
		id: "guide",
		parentId: "root_group",
		name: "使用教程",
		type: MENU,
		path: "/guide",
	},
];

export const DB_USER: User[] = [
	{
		id: "user_admin_id",
		username: "admin",
		password: "demo1234",
		avatar: "https://fe-scene-cdn.ziroom.com/0032x/778a1883630642b8ad438f648e644e5d.jpg",
		email: "admin@room.com",
	},
	{
		id: "user_test_id",
		username: "test",
		password: "demo1234",
		avatar: "https://fe-scene-cdn.ziroom.com/0032x/778a1883630642b8ad438f648e644e5d.jpg",
		email: "test@room.com",
	},
	{
		id: "user_guest_id",
		username: "guest",
		password: "demo1234",
		avatar: "https://fe-scene-cdn.ziroom.com/0032x/778a1883630642b8ad438f648e644e5d.jpg",
		email: "guest@room.com",
	},
];

export const DB_ROLE: Role[] = [
	{ id: "role_admin_id", name: "admin", code: "SUPER_ADMIN" },
	{ id: "role_test_id", name: "test", code: "TEST" },
];

export const DB_PERMISSION: Permission[] = [
	{ id: "permission_create", name: "permission-create", code: "permission:create" },
	{ id: "permission_read", name: "permission-read", code: "permission:read" },
	{ id: "permission_update", name: "permission-update", code: "permission:update" },
	{ id: "permission_delete", name: "permission-delete", code: "permission:delete" },
];

export const DB_USER_ROLE = [
	{ id: "user_admin_role_admin", userId: "user_admin_id", roleId: "role_admin_id" },
	{ id: "user_test_role_test", userId: "user_test_id", roleId: "role_test_id" },
];

export const DB_ROLE_PERMISSION = [
	{ id: "role_admin_permission_create", roleId: "role_admin_id", permissionId: "permission_create" },
	{ id: "role_admin_permission_read", roleId: "role_admin_id", permissionId: "permission_read" },
	{ id: "role_admin_permission_update", roleId: "role_admin_id", permissionId: "permission_update" },
	{ id: "role_admin_permission_delete", roleId: "role_admin_id", permissionId: "permission_delete" },

	{ id: "role_test_permission_read", roleId: "role_test_id", permissionId: "permission_read" },
	{ id: "role_test_permission_update", roleId: "role_test_id", permissionId: "permission_update" },
];
